module.exports = __webpack_public_path__ + "img/USMF1.3c82c464.svg";